import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { FeedbackStudentModel } from 'common/models/page-models/Feedback Students Model/feedback-student-data.model';
import { FeedbackStudentListingModel, FeedbackStudentGridParams } from 'common/models/page-models/Feedback Students Model/feedback-student-params.model';

@Injectable({
    providedIn: 'root'
})
export class FeedbackStudentGridDataService extends GridDataService<FeedbackStudentListingModel, FeedbackStudentModel> {
    constructor(http: SmApiService, protected override  ss: SystemService) {
        super(API_URL.getFeedbackFormMappedStudent, http, ss);
    }

    createInstance(): FeedbackStudentListingModel {
        return new FeedbackStudentListingModel();
    }

    getDeleteUrl(): string {
        return '';
    }

    getGridParams(): GridPostParams {
        return new FeedbackStudentGridParams();
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams();
        // console.log(queryParams, "QUERYYY");

        if (queryParams.id !== null) {
            payload['feedback_form_mapping_id'] = queryParams.id;
        }
        return payload;
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, param);
        apiRes[param].forEach((key) => {
            key.preview = key.showViewButton === 0 ? 'N/A' : 'view';
        });
        return apiRes;
    }
}
